var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNetWorth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.48193 0V0.385542V7.13253V7.51807H8.86747H15.6145H16V7.13253C16 3.19791 12.8021 0 8.86747 0H8.48193ZM9.25301 0.813253C12.4544 1.00942 14.9906 3.54558 15.1867 6.74699H9.25301V0.813253ZM7.13253 1.73494C3.19791 1.73494 0 4.93285 0 8.86747C0 12.8021 3.19791 16 7.13253 16C11.0672 16 14.2651 12.8021 14.2651 8.86747V8.48193H13.8795H7.51807V2.12048V1.73494H7.13253ZM6.74699 2.54819V8.86747V9.25301H7.13253H13.4518C13.2476 12.5856 10.5172 15.2289 7.13253 15.2289C3.61463 15.2289 0.771084 12.3854 0.771084 8.86747C0.771084 5.48279 3.41443 2.75239 6.74699 2.54819Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetWorth);
export default __webpack_public_path__ + "static/media/net_worth.0bac10c50c7659db7386f14acd1a0bc4.svg";
export { ForwardRef as ReactComponent };